import { useRef } from "react";
import { Divider, IconButton, Table } from "rsuite";
import { getOffset } from "rsuite/esm/DOMHelper";
import { Edit, Trash } from "@rsuite/icons";
function BlogList(props) {
  const data = props.data;
  const nodeRef = useRef();

  function onSelect(data) {
    props.onSelect(data);
  }

  function onDelete(id, name) {
    props.onDelete(id, name);
  }

  const ActionCell = ({ rowData, dataKey, ...props }) => {
    function handleAction() {
      onSelect(rowData[dataKey]);
    }
    function handleDelete() {
      onDelete(rowData[dataKey], rowData.label);
    }
    return (
      <Table.Cell {...props} className="link-group">
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          onClick={handleAction}
          icon={<Edit />}
        />
        <Divider vertical={true}></Divider>
        <IconButton
          size="sm"
          appearance="primary"
          color="red"
          onClick={handleDelete}
          icon={<Trash />}
        />
      </Table.Cell>
    );
  };

  return (
    <div
      id={props.id}
      ref={nodeRef}
      style={{
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Table
        loading={props.loading}
        height={window.innerHeight - getOffset(nodeRef.current).top}
        bordered={true}
        virtualized
        showHeader={true}
        className="striped-table"
        data={data}
        id="table"
        rowHeight={56}
      >
        <Table.Column flexGrow={1}>
          <Table.HeaderCell>Überschrift</Table.HeaderCell>
          <Table.Cell dataKey="label" />
        </Table.Column>


        <Table.Column width={131}>
          <Table.HeaderCell>Aktion</Table.HeaderCell>
          <ActionCell dataKey="parent_id" />
        </Table.Column>
      </Table>
    </div>
  );
}
export default BlogList;
